import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';
import '../../styles/landing.css';

const Landing = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const { t } = useTranslation(language);

    const handleEnter = () => {
        navigate('/home');
    };

    return (
        <div className="landing-container">
            <div className="landing-content">
                {/* Immagine mrFoundly in formato tondo sopra il logo */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '1rem'
                }}>
                    <div style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <div style={{
                            width: '180px',
                            height: '180px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            boxShadow: 'rgba(0, 0, 0, 0.3) 0px 4px 20px',
                            marginBottom: '5px'
                        }}>
                            <img 
                                src={`${process.env.PUBLIC_URL}/img/mrFoundly.jpg`} 
                                alt="Mr Foundly" 
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                        
                        {/* Testo "by Mr. Foundly" a destra dell'immagine, inclinato come scritto a mano */}
                        <span 
                            className="shadows-into-light-two-regular"
                            style={{
                                fontFamily: '"Shadows Into Light Two", cursive',
                                fontWeight: 400,
                                fontStyle: 'normal',
                                fontSize: '18px',
                                color: 'rgba(255, 255, 255, 0.9)',
                                position: 'absolute',
                                top: '160px',
                                right: '-15px',
                                whiteSpace: 'nowrap',
                                transform: 'rotate(-8deg)',
                                transformOrigin: 'center center 0px'
                            }}
                        >
                            {t('landing.byMrFoundly')}
                        </span>
                    </div>
                    
                    {/* Logo Foundly SVG */}
                    <div className="logo-container">
                        <img 
                            src={`${process.env.PUBLIC_URL}/img/logo.svg`} 
                            alt="Foundly" 
                            className="logo-svg"
                        />
                    </div>
                </div>
                
                {/* Descrizione */}
                <p className="description">
                    {t('landing.tagline')}
                </p>
                
                {/* Pulsante Discover Music */}
                <button 
                    onClick={handleEnter}
                    className="enter-button"
                >
                    {t('landing.discoverButton')}
                </button>
                
                {/* Pulsante Coffee */}
                <button 
                    onClick={() => navigate('/coffee')}
                    className="coffee-button"
                    style={{
                        marginTop: '20px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '2px solid rgba(255, 255, 255, 0.3)',
                        color: 'white',
                        padding: '12px 24px',
                        borderRadius: '50px',
                        fontSize: '16px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        backdropFilter: 'blur(10px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        margin: '20px auto 0'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                        e.target.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                        e.target.style.transform = 'translateY(0)';
                    }}
                >
                    <img 
                        src={`${process.env.PUBLIC_URL}/img/local_cafe_24dp_1F1F1F.svg`} 
                        alt="Coffee" 
                        style={{ 
                            width: '20px', 
                            height: '20px',
                            filter: 'invert(1)' // Rende l'icona bianca
                        }}
                    />
                    {t('landing.coffeeButton')}
                </button>

                <div className="landing-footer">
                    <a
                        className="privacy-link"
                        href="/privacy"
                    >
                        {t('privacy.linkLabel')}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Landing;
